import { FC } from 'react'
import QhseLibraryLayout from './QhseLibraryLayout'

const QhseLibraryPage: FC = () => {
  return <QhseLibraryLayout />
}

export default QhseLibraryPage
